<template>
  <div style="background-color: #f0f0f0">
    <!-- <div class="antiInfo">
    <Sertificate />
    </div>-->
    <!-- <div class="img" v-for="(item, index) in list" :key="index">
    <div class="bgi" v-if="item.msgItems[0].op.op.chinStatus">
      <img src="../assets/images/撕毁防伪.png" alt="" style="width: 100%; height: 100%;">
    </div>
    <div class="bgi" v-else>
      <img src="../assets/images/防伪.png" alt="" style="width: 100%; height: 100%;">
    </div>
    <div class="bgImg" v-if="item.msgItems[0].op.op.chinStatus">
      <img src="../assets/images/组 23165.png" alt="">
    </div>
    <div class="bgImg" v-else>
      <img src="../assets/images/完好框.png" alt="">
    </div>
    <div class="state">
        <div class="title" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#FA5151' : '#26907A;'}">
          芯片状态
        </div>
        <div class="title2" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#FA5151' : '#26907A'}">
          {{  item.msgItems[0].op.op.chinStatus ? "撕毁" : "完好" }}
        </div>
      </div>
      <div class="text1">
          当前已验证次数
          <span class="text2">{{ item.msgItems[0].op.op.polled_num }}</span>
      </div>
      <div class="time">
        {{ item.msgItems[0].op.op.created_date | formant }}
    </div>-->
    <!-- 区块链标识： -->
    <!-- <div class="goods-characteristic">
         <div class="goods-characteristic-inner" :style="{ borderColor: item.msgItems[0].op.op.chinStatus ? '#9DA5B2' : '#347B6C'}">
            <span @click="toBlockChain(item)" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#9DA5B2' : '#347B6C'}">
              区块链标识：{{ item.msgItems[0].txid }}</span>
           </div>
         </div>
    </div>
    <div style="margin-top: 226px;" class="details">
           <Fold :dataList="list">
             <template v-slot="itemData">
              <div class="goodsInfo">
                <div class="goodsInfo-text">
                  当前已验证次数<span style="margin-left: 22px; color: #000;">{{ itemData.itemData.op.op.polled_num }}</span>
                </div>
                <div class="goodsInfo-text">
                  验证时间<span style="margin-left: 59px; color: #000;">{{ itemData.itemData.op.op.created_date | formant }}</span>
                </div>
                <div class="goodsInfo-text">
                  防伪码<span style="margin-left: 73px; color: #000;">{{ itemData.itemData.op.op.mark_security_code }}</span>
                </div>
              </div>
             </template>
           </Fold>
    </div>-->
    <van-steps direction="vertical" :active="active">
      <van-step>
        <h3 style="color: #000000">
          第{{ dataList[0].op.op.polled_num }}次查询
        </h3>
        <div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_1.png" alt />
            </div>
            <div class="f-text" style="width: 145px; color: #595c63">
              区块链标识
            </div>
            <div
              class="f-info"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 2px;
                color: #26907a;
                font-weight: 400;
              "
              @click="toBlockChain1"
            >
              {{ dataList[0].txid }}
            </div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_2.png" alt />
            </div>
            <div class="f-text" style="color: #595c63">查询次数</div>
            <div class="f-info" style="color: #000">
              {{ dataList[0].op.op.polled_num }}
            </div>
          </div>

          <div class="f-box">
            <div>
              <img src="../assets/images/icon_3.png" alt />
            </div>
            <div class="f-text" style="color: #595c63">查询时间</div>
            <div class="f-info" style="color: #000">
              {{ dataList[0].ts | formant }}
            </div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_4.png" alt />
            </div>
            <div class="f-text" style="color: #595c63">物理防伪码</div>
            <div class="f-info" style="color: #000">
              {{ dataList[0].op.op.mark_security_code }}
            </div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_2.png" alt />
            </div>
            <div class="f-text" style="color: #595c63">ip</div>
            <div class="f-info" style="color: #000">
              {{ dataList[0].op.op.ip }}
            </div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_2.png" alt />
            </div>
            <div class="f-text" style="color: #595c63">地址</div>
            <div class="f-info" style="color: #000">
              {{ dataList[0].op.op.address }}
            </div>
          </div>
        </div>
      </van-step>
      <van-step v-for="(item, index) in listInfo" :key="index">
        <h3 style="color: #969799">第{{ item.op.op.polled_num }}次查询</h3>
        <div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_h1.png" alt />
            </div>
            <div class="f-text" style="width: 145px">区块链标识</div>
            <div
              class="f-info"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 2px;
                color: #26907a;
                font-weight: 400;
              "
              @click="toBlockChain(item)"
            >
              {{ item.txid }}
            </div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_h2.png" alt />
            </div>
            <div class="f-text">查询次数</div>
            <div class="f-info">{{ item.op.op.polled_num }}</div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_h3.png" alt />
            </div>
            <div class="f-text">查询时间</div>
            <div class="f-info">{{ item.ts | formant }}</div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_h4.png" alt />
            </div>
            <div class="f-text">物理防伪码</div>
            <div class="f-info">{{ item.op.op.mark_security_code }}</div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_h4.png" alt />
            </div>
            <div class="f-text">ip</div>
            <div class="f-info">{{ item.op.op.ip }}</div>
          </div>
          <div class="f-box">
            <div>
              <img src="../assets/images/icon_h4.png" alt />
            </div>
            <div class="f-text">地址</div>
            <div class="f-info">{{ item.op.op.address }}</div>
          </div>
        </div>
      </van-step>
    </van-steps>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Collapse, CollapseItem, Overlay } from "vant";
import { Icon } from "vant";
import { Step, Steps } from "vant";
import Sertificate from "../components/Sertificate.vue";

Vue.use(Overlay);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Icon);
Vue.use(Collapse);
Vue.use(CollapseItem);
// import Sertificate from '../components/Sertificate.vue'
// import Fold from '../components/fold.vue'
export default {
  components: {
    Sertificate,
  },
  props: {},
  data() {
    return {
      listDataAll: [],
      list: [],
      dataList: [],
      listInfo: [],
      active: 0,
      show: false,
      ts: "",
      txid: "",
    };
  },
  created() {
    console.log(JSON.parse(this.$route.query.item), "对象数据");
    this.dataList = JSON.parse(this.$route.query.item);
    this.dataList.forEach((item) => {
      item.op.op = JSON.parse(item.op.op);
    });
    // console.log(this.dataList.reverse());
    this.dataList.reverse();
    this.listInfo = this.dataList.slice(1);
    // this.listInfo = this.list.slice(1);
    // this.listDataAll = JSON.parse(window.localStorage.getItem("defalutObj"));
    // this.list = this.listDataAll.filter(
    //   (item) => item.trace_name === "防伪信息"
    // );
    // console.log(1111, this.list);
    // console.log(this.listDataAll);
    // this.list.forEach((item) => [(this.dataList = item.msgItems)]);
    // this.listInfo = this.dataList.slice(1);
  },
  methods: {
    toBlockChain(item) {
      this.show = true;
      this.ts = item.ts;
      this.txid = item.txid;
      // this.$router.push(`/Look?ts=${item.ts}&txid=${item.txid}`);
    },
    toBlockChain1() {
      this.show = true;
      this.ts = this.dataList[0].ts;
      this.txid = this.dataList[0].txid;
      // this.$router.push(
      //   `/Look?ts=${this.dataList[0].ts}&txid=${this.dataList[0].txid}`
      // );
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.f-box {
  display: flex;
  .f-text {
    width: 140px;
    height: 34px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;

    opacity: 1;
  }
  .f-info {
  }
}
.antiInfo {
  width: 100%;
  padding: 48px 32px;
}
.details {
  .goodsInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 694px;
    height: 214px;
    border: 2px solid #f3f3f3;
    opacity: 1;
    margin-top: 20px;
    margin: auto;
    .goodsInfo-text {
      margin-left: 20px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #919ab1;
      opacity: 1;
    }
  }
}
.img {
  background-color: #fff;
  .bgi {
    width: 100%;
    height: 364px;
  }
  .bgImg {
    position: absolute;
    top: 14%;
    left: 10%;
  }
  .goods-characteristic {
    position: absolute;
    bottom: 14%;
    width: 100%;
    //   padding: 48px 20px;
    padding: 48px 0;
    .goods-characteristic-inner {
      width: 530px;
      // height: 64px;
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .time {
    position: absolute;
    width: 280px;
    height: 28px;
    top: 54%;
    left: 7%;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #838483;
    opacity: 1;
  }
  .text1 {
    position: absolute;
    top: 226px;
    left: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919ab1;
    opacity: 1;
  }
  .text2 {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #292c40;
    opacity: 1;
    margin-left: 10px;
  }
  position: absolute;
  width: 750px;
  height: 500px;
  background-repeat: no-repeat;
  background-size: 100%;
  .state {
    position: relative;
    display: flex;

    position: absolute;
    top: 68px;
    left: 54px;
    // background-color: red;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 335px;
    height: 108px;
    .title {
      position: absolute;
      top: 50px;
      left: 38px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #26907a;
      opacity: 1;
      width: 112px;
      height: 40px;
      border-left: 0;
    }
    .title2 {
      position: absolute;
      top: 50px;
      right: 54px;
      font-size: 48px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #269079;
      opacity: 1;
      width: 96px;
      height: 66px;
    }
  }
}
</style>